// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2GVBw","content":"LayoutSettings_content__1H8uY"};